import { Env } from '../../../env';
import { ApiClient } from '../../../http/api_client';
import { StockAddressUpdateJsEnv } from '../../../models/currentsystem/club/stock_address_update_js_env';

export class StockAddressUpdateRepository {
    async updateStockAddress(
        zip1: string,
        zip2: string,
        areaCodeA: string | null, // 未ログインユーザーの時は必須
        areaCodeB: string | null, // 未ログインユーザーの時は必須
        adress1: string,
        adress21: string | null,
        adress22: string | null,
        adress3: string | null,
        adressId: string | null
    ): Promise<StockAddressUpdateJsEnv> {
        const request = { zip1: zip1, zip2: zip2, areaCdA: areaCodeA, areaCdB: areaCodeB, adr1: adress1, adr21: adress21, adr22: adress22, adr3: adress3, adrId: adressId }

        let result: any;
        try {
          result = await ApiClient.postAsForm( // 現行APIのリクエストはJSONではなく、FormDataで送信する必要
            `${Env.SETTING.userPublicApi.urlBase}ctg/apiStockDispAdrChange/`,
            request,
            {responseType: 'document'} // 現行APIのレスポンスはXMLのためdocumentで受け取る
          );
        } catch(err) {
          result = err.response.data
        }
        return new StockAddressUpdateJsEnv(
            result.getElementsByTagName('code')[0]?.textContent,
            result.getElementsByTagName('messege')[0]?.textContent,
            result.getElementsByTagName('address')[0]?.textContent
        )
    }
}
